import React, { Component } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import LoadingReplace from 'appSrc/components/Shards/Loading/LoadingReplace';
import AllInterestsTable from './Table';
import AdminPageHead from '../../Common/PageHead';
import NewInterestModal from '../../Modals/Interest/NewInterestModal';
import style from './styles/style.module.css';

class AllInterestsView extends Component {
    constructor( props ) {
        super( props );
        this.state = {
            fetching: true,
            interests: [],
            newModal: false,
        };
        this.interestQueryObject = {
            sort: 'interest,interestid',
        };

        this.loadInterests();
    }
    onColumnSort = ( value ) => {
        if( this.interestQueryObject.sort == value ) {
            value = `-${ value }`;
        }
        this.interestQueryObject.page = 1;
        this.interestQueryObject.sort = value || undefined;
        this.setState( ( prevState ) => {
            prevState.fetching = true;
            prevState.interests = [];
            return prevState;
        } );
        this.loadInterests();
    }
    onSearch = ( value ) => {
        this.interestQueryObject.page = 1;
        this.interestQueryObject.search = value || undefined;
        this.setState( ( prevState ) => {
            prevState.fetching = true;
            prevState.interests = [];
            return prevState;
        } );
        this.loadInterests();
    }
    loadInterests = () => {
        return this.props.getInterests( this.interestQueryObject )
        .then( ( interests ) => {
            this.interestQueryObject.page++;
            this.setState( ( prevState ) => {
                prevState.fetching= false;
                prevState.interests = prevState.interests.concat( interests );
                return prevState;
            } );
            return interests;
        } );
    }
    interestUpdated = ( index, interest ) => {
        this.setState( ( altState ) => {
            if( interest !== null ) {
                altState.interests[ index ] = interest;
                altState.interests = altState.interests.slice( 0 );
            } else {
                altState.interests = altState.interests.slice( 0, index ).concat( altState.interests.slice( index +1 ) );
            }
            return altState;
        } );
    }
    openNewModal = () => {
        this.setState( { newModal: true } );
    }
    onNewModalClose = () => {
        this.setState( { newModal: false } );
    }
    onNewModalSubmit = ( newInterest ) => {
        this.setState( ( altState ) => {
            altState.interests.unshift( newInterest );
            altState.interests = altState.interests.slice( 0 );
            altState.newModal = false;
            return altState;
        } );
    }

    render() {
        const { fetching, interests } = this.state;

        return (
            <section className={ style.page }>
                <AdminPageHead title='Interests'
                onSearch={ this.onSearch }
                tabs={ [
                    { label: 'View All', to: '/admin/interests' },
                ] }
                buttons={ [
                    { label: '+ Add New Interest', onClick: this.openNewModal },
                ] } />
                <div className={ style.body }>
                    <section className={ style.allList }>
                        { fetching ?
                            <LoadingReplace />
                            :
                            <AllInterestsTable
                            interests={ interests }
                            onColumnSort={ this.onColumnSort }
                            currentSort={ this.interestQueryObject.sort }
                            onInterestUpdated={ this.interestUpdated }
                            elementHeight={ 70 } />
                        }
                    </section>
                </div>
                { this.state.newModal &&
                    <NewInterestModal closeModal={ this.onNewModalClose }
                    onSubmit={ this.onNewModalSubmit } />
                }
            </section>
        );
    }
}

const mapDispatchToProps = () => {
    return {
        getInterests: ( queryObject ) => {
            return dAPI.get( '/admin/interests', queryObject );
        },
    };
};

export default connect( null, mapDispatchToProps )( AllInterestsView );
